/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { isNative, getNetworkStatus, shareContent } from "../utils/capacitor";
import { Network } from "@capacitor/network";

export const useMobileFeatures = () => {
  const [isOnline, setIsOnline] = useState(true);
  const [networkType, setNetworkType] = useState<
    "wifi" | "cellular" | "none" | "unknown"
  >("unknown");

  useEffect(() => {
    if (isNative) {
      // Network status listener
      Network.addListener("networkStatusChange", (status) => {
        setIsOnline(status.connected);
        setNetworkType(status.connectionType);
      });

      // Get initial status
      getNetworkStatus().then((status) => {
        setIsOnline(status.connected);
        setNetworkType(status.connectionType);
      });
    } else {
      // Web fallback
      setIsOnline(navigator.onLine);
      window.addEventListener("online", () => setIsOnline(true));
      window.addEventListener("offline", () => setIsOnline(false));
    }

    return () => {
      if (isNative) {
        Network.removeAllListeners();
      }
    };
  }, []);

  const shareJob = async (job: any) => {
    await shareContent({
      title: `Job Opportunity: ${job.title}`,
      text: `Check out this job opening at ${job.company}: ${job.description}`,
      url: window.location.href,
      dialogTitle: "Share Job Opportunity",
    });
  };

  return {
    isNative,
    isOnline,
    networkType,
    shareJob,
  };
};
